// import execInstallGlobalModules from './install-global-modules'
// import execAxios from './axios'
import execVueSizeTracker from './vue-size-tracker-plugin';
import execFilters from './filters';
// import execI18n from './i18n'
import execBus from './bus';
import sentry from './sentry';
import vueDayjs from './vue-dayjs';
import execIframeEvents from './iframe-events-plugin';
export default function ({ router }) {
  //   execInstallGlobalModules()
  //   execAxios()
  execVueSizeTracker();
  execFilters();
  //   execI18n()
  execBus();
  sentry(router);
  vueDayjs();
  execIframeEvents();
}
